import i18n from 'i18next';
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";

if (!localStorage.getItem('i18nextLng')) {
    localStorage.setItem('i18nextLng', 'fr');
}

i18n
    .use(i18nBackend)
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "fr",
        // lng: "en",
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `./i18n/{{lng}}.json`,
        },
    });

export default i18n;